import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICompanyEngagementHistory } from "../../../message-models/company-engagement-history.interface";
import { CompanyEngagementHistory } from "../../../message-models/company-engagement-history.class";
import { EngagementModalService } from "../../services/engagement-modal.service";
import { IOperative } from "../../../message-models/operative.interface";
import { OperativeInfo } from "../../../domain-model/operative-info.class";
import { IJobTitleInfo } from "../../../message-models/job-title.interface";
import { IRiskInfo } from "../../../message-models/risk-info.interface";
import { IJobLevelInfo } from "../../../message-models/job-level.interface";
import { OperativesService } from "../../services/operatives.service";
import { DatePipe } from '@angular/common';
import { ExportExcelService } from 'src/app/common/services/export-excel.service';
import { IAllowedOperations } from "../../../users/models/userInfo.interface";
import { DegreeOfSupervisionString, RiskMatrixLevel } from "../../../message-models/risk-matrix-level.enum";
import { IEmploymentStatus } from '../../../message-models/employment-status.interface';
import { MenuItem } from 'primeng/api';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';

@Component({
  selector: 'app-operative-history',
  templateUrl: './operative-history.component.html',
  styleUrls: ['./operative-history.component.scss']
})
export class OperativeHistoryComponent implements OnInit {
  @Input() engagementHistory: CompanyEngagementHistory[] = [];
  @Input() operative: OperativeInfo = {} as OperativeInfo;

  @Input() allOperativeTypes: IOperativeTypeInfo[] = [];
  @Input() allBusinessUnits: IBusinessUnitInfo[] = [];
  @Input() allJobTitles: IJobTitleInfo[] = [];
  @Input() allCompanyJobTitles: ICompanyJobTitle[] = [];
  @Input() allJobLevels: IJobLevelInfo[] = [];
  @Input() allRisks: IRiskInfo[] = [];
  @Input() allEmploymentStatuses: IEmploymentStatus[] = [];

  @Input() allowOperations: IAllowedOperations = {} as IAllowedOperations;
  @Input() addButtonText = 'Add';

  @Output() addRoleHistoryRequested: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deleteRoleHistoryRequested: EventEmitter<ICompanyEngagementHistory> = new EventEmitter<ICompanyEngagementHistory>();
  @Output() refreshOperativeSuggested: EventEmitter<boolean> = new EventEmitter<boolean>();

  columns: any[];
  exportColumns: any[];
  engagementHistoriesToExport: any[] = [];
  operativeHistoryLoading: boolean = false;
  degreeOfSupervisionString: typeof DegreeOfSupervisionString = DegreeOfSupervisionString;
  rowMenuItems: MenuItem[];

  constructor(private engagementModalService: EngagementModalService, private operativesService: OperativesService,
    private datePipe: DatePipe, private exportExcelService: ExportExcelService) { }
  isOnMobile: boolean = false;

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    // this.engagementHistory?.forEach(item => {
    //   item.supervisionString = item.jobTitle?.name === 'Qualified Supervisor' ? 'QS' : this.degreeOfSupervisionString[item.riskMatrixLevel];
    // })
    this.columns = [{ field: 'from', header: 'From', type: 'date' },
    { field: 'to', header: 'To', type: 'date' },
    { field: 'businessUnit', header: 'Business Unit', type: 'text' },
    { field: 'operativeType', header: 'Operative Type', type: 'text' },
    { field: 'jobTitle', header: 'Job Role', type: 'text' },
    { field: 'risk', header: 'Work Risk', type: 'text' },
    { field: 'jobLevel', header: 'Job Level', type: 'text' },
    //{ field: 'employmentStatus', header: 'Employment Status', type: 'text' },
    { field: 'riskMatrixLevel', header: 'Supervision', type: 'enum' }
    ];
    this.exportColumns = [{ field: 'from', header: 'From' },
    { field: 'to', header: 'To' },
    { field: 'businessUnit', header: 'Business Unit' },
    { field: 'operativeType', header: 'Operative Type' },
    { field: 'jobTitle', header: 'Job Role' },
    { field: 'risk', header: 'Work Risk' },
    { field: 'jobLevel', header: 'Job Level' },
    //{ field: 'employmentStatus', header: 'Employment Status', type: 'text' },
    { field: 'riskMatrixLevel', header: 'Supervision', type: 'enum' }
    ];

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteRoleHistoryClicked($event)
      }
    ]
  }

  addHistoryEntry() {
    this.addRoleHistoryRequested.emit(true);
  }

  viewEngagement(engagement: ICompanyEngagementHistory, openInEdit: boolean = false) {
    this.engagementModalService.openEngagementEditorModal(
      "Role for " + this.operative.getFullName(),
      this.allJobTitles,
      this.allCompanyJobTitles,
      this.allJobLevels,
      this.allRisks,
      this.allOperativeTypes,
      this.allBusinessUnits,
      this.allEmploymentStatuses,
      openInEdit,
      engagement).subscribe(modalRef => {
        modalRef.content.cancelEngagementClicked.subscribe(result => {
          this.engagementModalService.engagementModalRef.dynamicDialogRef.close();
        });
        modalRef.content.saveEngagementClicked.subscribe(engagement => {
          this.operativeHistoryLoading = true;
          this.engagementModalService.engagementModalRef.dynamicDialogRef.close();
          this.operativesService.createOrUpdateEngagement(engagement).subscribe(engagement => {
            this.operativeHistoryLoading = false;
            this.refreshOperativeSuggested.emit(true);
          });
        })
      })
  }

  exportToExcel() {
    this.engagementHistoriesToExport = [];
    this.engagementHistory.forEach(element => {
      const tempObject = {
        from: this.datePipe.transform(element.from?.dateTime, 'dd/MM/yyyy'),
        to: this.datePipe.transform(element.to?.dateTime, 'dd/MM/yyyy'),
        businessUnit: element.businessUnit?.name,
        operativeType: element.operativeType?.name,
        jobTitle: element.jobTitle?.name,
        risk: element.risk?.name,
        jobLevel: element.jobLevel?.name,
        employmentStatus: element.employmentStatus?.name,
        riskMatrixLevel: element.supervisionString
        // riskMatrixLevel:  this.degreeOfSupervisionString[element?.riskMatrixLevel]
      };

      this.engagementHistoriesToExport.push(tempObject);
    });
    this.exportExcelService.exportToExcel(this.engagementHistoriesToExport, this.exportColumns, 'OperativeRoles');

  }

  deleteRoleHistoryClicked(roleHistory: ICompanyEngagementHistory) {
    this.deleteRoleHistoryRequested.emit(roleHistory);
  }

  getEngagementRiskColour(history: ICompanyEngagementHistory) {
    switch (history.riskMatrixLevel) {
      case RiskMatrixLevel.low:
        return 'darkgreen';
      case RiskMatrixLevel.warning:
        return 'darkorange';
      case RiskMatrixLevel.danger:
        return 'red';
    }
    return 'black';
  }
}
